
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"120","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.12 22.47V16a7 7 0 1113.94 0v6.52M86.88 108.63a16.79 16.79 0 10-33.57 0M93.12 81.69l.13-13.64H48.03M93.25 67.73a22.61 22.61 0 00-45.22 0","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M65.95 45.13v-8.38h9.38v8.38M70.64 27.5v9.25M32.09.69v7.97M36.4 81.16h67.02v27.47H36.4z"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M36.66 108.63H16.59V38.97H47.6v42.19"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M21.02 39.13V22.84h22.15v16.29"}})])
          )
        }
      }
    